import React from 'react';
import * as Interfaces from 'interfaces';
import { getStreetAddress } from 'services/permitService/helper';
import { CovidAddress } from 'interfaces/common';
import { ApplicationDetails } from 'steps/styled';

type Props = Interfaces.Common.FormValues;

const getAddressDetails = (address?: CovidAddress) => {
  return address?.isOverseasAddress
    ? `${address.overseas.info.basic} ${address.overseas.country}`
    : `${getStreetAddress(address?.fullDetails?.fullAddress)} ${address?.fullDetails?.suburb} ${
        address?.fullDetails?.postCode
      }`;
};

export default function InlinePermit({ identity: { givenName, familyName }, assess }: Props) {
  const address =
    assess.Depart.from === 'other' ? assess.Depart.homeAddress : assess.Depart.fromAddress;

  return (
    <>
      <ApplicationDetails>
        Applicant name:
        <br />
        <strong data-testid='ApplicationName-Details'>
          {givenName} {familyName}
        </strong>
      </ApplicationDetails>
      <ApplicationDetails>
        Address:
        <br />
        <strong data-testid='ApplicationAddress-Details'>{getAddressDetails(address)}</strong>
      </ApplicationDetails>
    </>
  );
}
